import ActividadesAbiertas from "../actividadesAbiertas/ActividadesAbiertas";
import AuditoriasSGAbiertas from "../auditoriasSG/AuditoriasSGAbiertas";

export default function Home() {
  return (
    <>
      <ActividadesAbiertas />
      <AuditoriasSGAbiertas />
    </>
  );
}
